import DecisionFatigueSection from "./DecisionFatigueSection.js";
import DecisionConfidenceSection from "./DecisionConfidenceSection.js";
import CognitiveBiasesSection from "./CognitiveBiasesSection.js";
import AssumptionsVsFactsSection from "./AssumptionsVsFactsSection.js";
import ClearDecisionMakingSection from "./ClearDecisionMakingSection.js";
import DifficultConversationsSection from "./DifficultConversationsSection.js";
import LeadershipDecisionsSection from "./LeadershipDecisionsSection.js";
import ReflectionBeforeActionSection from "./ReflectionBeforeActionSection.js";

const SECTION_COMPONENTS = {
  "decision-fatigue": DecisionFatigueSection,
  "decision-confidence": DecisionConfidenceSection,
  "cognitive-biases": CognitiveBiasesSection,
  "assumptions-vs-facts": AssumptionsVsFactsSection,
  "clear-decision-making": ClearDecisionMakingSection,
  "difficult-conversations": DifficultConversationsSection,
  "leadership-decisions": LeadershipDecisionsSection,
  "reflection-before-action": ReflectionBeforeActionSection,
};

export default SECTION_COMPONENTS;
